var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-tabs',{staticStyle:{"border-bottom":"1px solid var(--v-foreground-5-base)"},attrs:{"hide-slider":"","active-class":"primary white--text","background-color":"transparent","height":"36"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',[_vm._v(_vm._s(_vm.$t('forms_create.create')))]),_c('v-tab',[_vm._v(_vm._s(_vm.$t('forms_create.duplicate')))])],1),_c('v-tabs-items',{staticStyle:{"background-color":"transparent"},attrs:{"dark":_vm.isDark},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',[_c('v-card-text',{staticStyle:{"padding":"0px"}},[_c('MutationForm',{attrs:{"no-reset":"","mutation":"createForm","constants":{ environmentId: _vm.environmentId },"submitButtonIcon":"add","submitButtonText":_vm.$t('forms_create.create'),"environment-variables":{ environmentId: _vm.environmentId },"schema":{
            environmentId: {
              __graphQLType: 'ID'
            },
            name: {
              label: _vm.$t('forms_create.schema.name.label'),
              type: 'string',
              description: _vm.$t('forms_create.schema.name.description'),
              newDesign: true,
              isDark: _vm.isDark
            },
            title: {
              label: _vm.$t('forms_create.schema.title.label'),
              type: 'string',
              optional: true,
              description: _vm.$t('forms_create.schema.title.description'),
              newDesign: true,
              isDark: _vm.isDark
            },
            collectionId: {
              label: _vm.$t('forms_create.schema.collectionId.label'),
              type: 'string',
              fieldType: 'collectionSelect',
              __graphQLType: 'ID',
              description: _vm.$t('forms_create.schema.collectionId.description'),
              newDesign: true,
              isDark: _vm.isDark
            },
            type: {
              label: _vm.$t('forms_create.schema.type.label'),
              type: 'string',
              fieldType: 'select',
              fieldOptions: {
                options: [
                  {
                    label: _vm.$t('forms_create.schema.type.create'),
                    value: 'create'
                  },
                  {
                    label: _vm.$t('forms_create.schema.type.update'),
                    value: 'update'
                  },
                  {
                    label: _vm.$t('forms_create.schema.type.upsert'),
                    value: 'upsert'
                  }
                ]
              },
              newDesign: true,
              isDark: _vm.isDark
            },
            updateVariableName: {
              label: _vm.$t('forms_create.schema.updateVariable.label'),
              type: 'string',
              description: _vm.$t(
                'forms_create.schema.updateVariable.description'
              ),
              // why
              formFieldType: 'editable',
              requiredType: 'editable',
              requiredField: 'type',
              requiredValue: 'update',
              showField: true,
              newDesign: true,
              isDark: _vm.isDark
            }
          }},on:{"success":function($event){return _vm.$emit('create', $event)},"error":function($event){return _vm.$emit('error', $event)}}},[_c('v-btn',{staticClass:"rounded-sm",staticStyle:{"border":"2px solid var(--v-primary-base)"},attrs:{"slot":"left-buttons","outlined":""},on:{"click":function($event){return _vm.$emit('dismiss')}},slot:"left-buttons"},[_vm._v(_vm._s(_vm.$t('forms_create.cancelBtn')))])],1)],1)],1),_c('v-tab-item',[_c('v-card-text',{staticClass:"pa-0"},[_c('div',{staticClass:"pa-4"},[_c('div',{staticClass:"overline"},[_vm._v(_vm._s(_vm.$t('forms_create.duplicates')))]),_c('div',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.$t('forms_create.whatDuplicate'))+" ")]),_c('div',{staticClass:"overline"},[_vm._v(_vm._s(_vm.$t('forms_create.WontDupli')))]),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t('forms_create.whatWontDupli1')))]),_c('div',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.$t('forms_create.whatWontDupli2'))+" ")])]),_c('MutationForm',{attrs:{"no-reset":"","mutation":"duplicateForm","environmentVariables":{ environmentId: _vm.environmentId },"submitButtonIcon":"content_copy","submitButtonText":_vm.$t('forms_create.duplicate'),"schema":{
            formId: {
              __graphQLType: 'ID',
              label: 'Formulario a copiar',
              fieldType: 'componentSelect',
              fieldOptions: {
                componentTypeName: 'forms'
              },
              newDesign: true
            },
            newName: {
              label: _vm.$t('forms_create.schema.newName.label'),
              type: 'string',
              description: _vm.$t('forms_create.schema.newName.description'),
              newDesign: true,
              isDark: _vm.isDark
            }
          }},on:{"success":function($event){return _vm.$emit('create', $event)},"error":function($event){return _vm.$emit('error', $event)}}},[_c('v-btn',{staticClass:"rounded-sm",staticStyle:{"border":"2px solid var(--v-primary-base)"},attrs:{"slot":"left-buttons","outlined":""},on:{"click":function($event){return _vm.$emit('dismiss')}},slot:"left-buttons"},[_vm._v(_vm._s(_vm.$t('forms_create.cancelBtn')))])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }